export const AttendanceHeader = [
  {
    name: "Date",
    field: "date",
  },
  {
    name: "In Time",
    field: "punch_in",
  },
  {
    name: "Out Time",
    field: "punch_out",
  },
  {
    name: "Working Hours",
    field: "working_hours",
  },
  {
    name: "Attendace",
    field: "attendace",
  },

  // {
  //   name: "Lat/Long",
  //   field: "location",
  // },
  {
    name: "Approved by",
    field: "approver",
  },
  {
    name: "Action",
    field: "action",
  },
];

export const TeamTableData = [
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
  {
    Department: "Information Technology",
    Designation: "Software Engineer",
    Action: "Edit",
  },
];

export const AttendanceHeaderALL = [
  {
    name: "Team Name",
    field: "team_name",
  },

  {
    name: "Type",
    field: "work_type",
  },
  
  {
    name: "In-Time",
    field: "in_time",
  },
  {
    name: "Out Time",
    field: "out_time",
  },
  {
    name: "Working Hours",
    field: "working_hours",
  },
  {
    name: "Overtime Hours",
    field: "overtime_hours",
  },

  // {
  //   name: "Location",
  //   field: "location",
  // },

  // {
  //   name: "Action",
  //   field: "action",
  // },
];

export const AttendanceAllData = [
  {
    id: 1,
    team_name: "Toushar Bhalla",
    in_time: "11:00 AM",
    out_time: "07:00 PM",
    working_hours: "12.0",
    overtime_hours: "0.1",
    type: "Present",
    location: "View",
    action: "",
  },

  {
    id: 2,
    team_name: "Toushar Bhalla",
    in_time: "11:00 AM",
    out_time: "07:00 PM",
    working_hours: "12.0",
    overtime_hours: "0.1",
    type: "Present",
    location: "View",
    action: "",
  },

  {
    id: 3,
    team_name: "Toushar Bhalla",
    in_time: "11:00 AM",
    out_time: "07:00 PM",
    working_hours: "12.0",
    overtime_hours: "0.1",
    type: "Half Day",
    location: "View",
    action: "",
  },
];
